;(() => {
	const parseBool = (value) => value === true || value === 'true'

	const gapMap = {
		small: 16,
		medium: 24,
		large: 32,
	}

	const getOriginalSlides = (slider) =>
		Array.from(
			slider.querySelectorAll('.card-carousel__slide:not([data-card-carousel-clone])')
		)

	const removeClones = (slider) => {
		slider
			.querySelectorAll('[data-card-carousel-clone]')
			.forEach((slide) => slide.remove())
	}

	const cleanClone = (clone) => {
		clone.setAttribute('data-card-carousel-clone', 'true')
		Array.from(clone.attributes).forEach((attribute) => {
			if (attribute.name.indexOf('data-shopify') === 0) {
				clone.removeAttribute(attribute.name)
			}
		})

		clone.querySelectorAll('[id]').forEach((element) => {
			element.removeAttribute('id')
		})
	}

	const prepareLoopSlides = (slider, slidesPerView) => {
		const wrapper = slider.querySelector('.card-carousel__wrapper')
		if (!wrapper) return 0

		removeClones(slider)

		const originalSlides = getOriginalSlides(slider)
		const requiredSlides = Math.max(slidesPerView * 3, originalSlides.length)

		if (originalSlides.length < 2) return originalSlides.length

		let cloneIndex = 0
		while (wrapper.children.length < requiredSlides) {
			const clone = originalSlides[cloneIndex % originalSlides.length].cloneNode(true)
			cleanClone(clone)
			wrapper.appendChild(clone)
			cloneIndex += 1
		}

		return originalSlides.length
	}

	const destroySlider = (slider) => {
		if (!slider || !slider.swiper) return

		slider.swiper.destroy(true, true)
		removeClones(slider)
	}

	const initSlider = (slider) => {
		if (!slider || typeof Swiper === 'undefined') return

		if (slider.swiper) {
			destroySlider(slider)
		}

		const slidesPerView = parseInt(slider.dataset.slides, 10) || 4
		const originalSlideCount = prepareLoopSlides(slider, slidesPerView)

		if (!originalSlideCount) return

		const autoplayEnabled = parseBool(slider.dataset.autoplay)
		const pauseOnHover = parseBool(slider.dataset.pauseOnHover)
		const speed = parseInt(slider.dataset.speed, 10) || 6000
		const section = slider.closest('.card-carousel')
		const isSeparators = section?.classList.contains('multicolumn--separators')
		const spaceBetween = isSeparators ? 0 : gapMap[slider.dataset.gap] || gapMap.large
		const canLoop = originalSlideCount > 1

		new Swiper(slider, {
			loop: canLoop,
			speed: autoplayEnabled ? speed : 700,
			slidesPerView: 1.08,
			spaceBetween: 16,
			allowTouchMove: true,
			watchSlidesProgress: true,
			mousewheel: {
				forceToAxis: true,
			},
			autoplay: autoplayEnabled && canLoop
				? {
						delay: 1,
						disableOnInteraction: false,
						pauseOnMouseEnter: pauseOnHover,
					}
				: false,
			breakpoints: {
				576: {
					slidesPerView: Math.min(slidesPerView, 2),
					spaceBetween,
				},
				990: {
					slidesPerView,
					spaceBetween,
				},
			},
		})
	}

	const initSection = (section) => {
		if (!section) return

		section.querySelectorAll('.js-card-carousel').forEach(initSlider)
	}

	const destroySection = (section) => {
		if (!section) return

		section.querySelectorAll('.js-card-carousel').forEach(destroySlider)
	}

	const currentSection = document.currentScript?.parentElement || document

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => initSection(currentSection))
	} else {
		initSection(currentSection)
	}

	if (!window.cardCarouselEventsBound) {
		window.cardCarouselEventsBound = true

		document.addEventListener('shopify:section:load', (event) => {
			initSection(event.target)
		})

		document.addEventListener('shopify:section:unload', (event) => {
			destroySection(event.target)
		})
	}
})()
